import { BadgeProps, Badge as VdsBadge } from "@vds/badges";


const Badge = ({ children, ...rest }: BadgeProps) => {
  return <VdsBadge children={children} {...rest} />;
};

export default Badge;
